import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { RolElement, WorkerElement, ListWorkers } from '../models/worker.model';

const API_URL = environment.API_URL;

/**
 * Respuesta estándar de la API
 */
export interface ApiResponse {
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class WorkerService {

  lstRoles: RolElement[] = [];
  lstWorkers: ListWorkers[] = [];

  constructor(private http: HttpClient) {}

  items: any = [];

  // =========================
  // WORKERS CRUD
  // =========================

  getAllWorkers(company_id: number): Observable<WorkerElement[]> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/workers`;
    return this.http.get<WorkerElement[]>(API_URL_USR);
  }

  getWorkerById(id: number, company_id: number): Observable<WorkerElement[]> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/workers/${id}`;
    return this.http.get<WorkerElement[]>(API_URL_USR);
  }

  addWorker(user: WorkerElement, company_id: number): Observable<ApiResponse> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/workers`;
    return this.http.post<ApiResponse>(API_URL_USR, user);
  }

  updateWorker(id: number, user: WorkerElement, company_id: number): Observable<ApiResponse> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/workers/${id}`;
    return this.http.put<ApiResponse>(API_URL_USR, user);
  }

  deleteWorker(id: number, company_id: number): Observable<ApiResponse> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/workers/${id}`;
    return this.http.delete<ApiResponse>(API_URL_USR);
  }

  postFile(data: any[], company_id: number): Observable<ApiResponse> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/workers/import`;
    return this.http.post<ApiResponse>(API_URL_USR, data);
  }

  // =========================
  // WORKERS LIST MAPPING
  // =========================

  getWorkersList(company_id: number): Observable<ListWorkers[]> {
    return this.getAllWorkers(company_id).pipe(
      map((res: any) => {
        const items: ListWorkers[] = [];

        const data = res?.data ?? [];

        for (const itm of data) {
          items.push({
            value: itm.id,
            viewValue: `${itm.first_name} ${itm.last_name}`
          });
        }

        return items;
      }),
      catchError(error => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  // =========================
  // FILE DOWNLOAD
  // =========================

  downloadLayout(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      catchError(error => {
        console.error('Error al descargar el archivo', error);
        return throwError(() => error);
      })
    );
  }

  saveFile(blob: Blob): void {
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'Plantilla.xlsx';

    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  }
}